import { EncuestaDTO, RespuestaUsuario } from "@DTOS";
import * as XLSX from "xlsx";
import { obtenerNombreGenero, obtenerNombreRangoEdad } from "@shared/enums";
import { ExporterRawData } from "@shared/clases";

import "@extensiones";
import { CuestionariosUtils } from "@shared/utils";

const COLUMNAS_INICIALES = ["User ID", "Pais", "Genero", "Rango de edad"];

export abstract class ExporterRawDataExcel {
    public static obtener(encuesta: EncuestaDTO, cuestionariosUtils: CuestionariosUtils): ExporterRawDataExcel {
        return new ExporterRawDataExcelImpl(encuesta, cuestionariosUtils);
    }

    abstract exportar(respuestasUsuario: RespuestaUsuario[]): void;
}

class ExporterRawDataExcelImpl implements ExporterRawDataExcel {

    constructor(private encuesta: EncuestaDTO, private cuestionariosUtils: CuestionariosUtils) {}

    public exportar(respuestasUsuario: RespuestaUsuario[]): void {
        const workbook = XLSX.utils.book_new();

        const respuestas: any[] = respuestasUsuario.map(respuestaUsuario =>
            this.procesarRespuestasUsuario(respuestaUsuario));

        const dataRespuestas = XLSX.utils.json_to_sheet(respuestas, {
            header: this.obtenerHeadersRespuestas()
        });

        XLSX.utils.book_append_sheet(workbook, dataRespuestas, "Respuestas");

        XLSX.writeFile(workbook, "Respuestas en Raw Data.xlsx");
    }

    private procesarRespuestasUsuario(respuestaUsuario: RespuestaUsuario): any {
        const respuestas: any = {};

        respuestas["User ID"] = respuestaUsuario.id;
        respuestas.Pais = respuestaUsuario.pais?.nombre ?? "";
        respuestas.Genero = respuestaUsuario.genero != null ? obtenerNombreGenero(respuestaUsuario.genero) : "";
        respuestas["Rango de edad"] = respuestaUsuario.rangoEdad != null ? obtenerNombreRangoEdad(respuestaUsuario.rangoEdad) : "";

        respuestaUsuario.respuestas.forEach(respuesta => {
            const pregunta = this.cuestionariosUtils.obtenerPreguntasParseadas(this.encuesta)
                .find(preguntaDTO => preguntaDTO.esMatriz() ?
                    preguntaDTO.preguntas?.some(preguntaMatriz =>
                        preguntaMatriz.items.some(itemMatriz => itemMatriz.id === respuesta[0]))
                    :
                    preguntaDTO.items.some(item => item.id === respuesta[0]));

            if (pregunta == null) {
                return;
            }

            ExporterRawData.exportar(respuestas, respuesta, pregunta);
        });

        return respuestas;
    }

    private obtenerHeadersRespuestas(): string[] {
        return [...COLUMNAS_INICIALES, ...(this.encuesta.preguntas?.map(pregunta => pregunta.texto) ?? [])];
    }
}
